import { ILatLng } from '@ionic-native/google-maps';

type OnClickFunction = (point: ILatLng) => void;

export interface MapOptions {
	disable?: boolean;
	onclick?: OnClickFunction;
}

